import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { ChromePicker } from 'react-color'

const ColorFieldComponent = (props: any) => {
    const [value, setValue] = useState('');
    const [colorVisible, setColorVisible] = useState(false);
    let timer: NodeJS.Timeout;

    useEffect(() => {
        setValue(props.model[props.field] ?? '');
    }, [props.model]);

    function setModelEvent(value: any) {
        setValue(value);
        props.model[props.field] = value;

        if (props.colorChangedCallback == null) {
            return;
        }

        props.colorChangedCallback(props.field, props.type ?? 'fill');
    }

    function setColorVisibleEvent(value: boolean) {
        timer = setTimeout(() => {
            if (value) {
                document.querySelectorAll('.div-color').forEach((el: any) => el.style.display = "none");
            }
            setColorVisible(value);
        }, 500);
    }
    return (
        <div>
            <div className={props.divClassName} onMouseLeave={() => setColorVisibleEvent(false)} onMouseEnter={() => { if (timer != null) clearTimeout(timer); }}>
                <TextField
                    className={props.type}
                    fullWidth
                    required={props.required}
                    onChange={(e: any) => setModelEvent(e.target.value)}
                    onClick={() => setColorVisible(true)}
                    label={props.label}
                    value={value}
                    variant="outlined"
                    style={{ marginRight: 10 }} />

                {!colorVisible ? '' :
                    <div style={{ position: "absolute", zIndex: 100 }} className="div-color">
                        <ChromePicker onChange={(c) => { setModelEvent(c.hex) }} color={value} />
                    </div>
                }
            </div>
        </div>
    )
}

export default ColorFieldComponent